import type { ILocaleKeypath } from "~/composables/use-locale";

type FormatDistanceProps = {
  distance: number;
  translationConfig: {
    t: (
      key: ILocaleKeypath,
      params?: Record<string, string | number>,
    ) => string;
  };
};

export const formatDistance = ({
  distance,
  translationConfig: { t },
}: FormatDistanceProps): string | undefined => {
  if (typeof distance !== "number") return undefined;

  const distanceKm = distance / 1000;

  return distanceKm < 1
    ? t("components.outlet_selection.distance_m", {
        distance: Math.floor(distance),
      })
    : t("components.outlet_selection.distance_km", {
        distance: Math.floor(distanceKm),
      });
};
